import React, { useMemo } from 'react'
import FormManager from './FormManager'
import { useLocation } from 'react-router'
import MiscellaneousFormsPage from '../MiscRecords/MiscellaneousFormsPage'

const FormManagerWrapper = (props) => {
  const location = useLocation()
  const { sublinks } = props

  const isMiscRecordsType = useMemo(() => {
    const parts = location.pathname.split('/')
    const sublink = sublinks.find(x => x.parameter === parts[parts.length - 1])
    if (sublink) {
      return sublink.IsMiscRecordsType
    } else {
      return false
    }
  }, [location, sublinks])

  if (isMiscRecordsType) return <MiscellaneousFormsPage {...props} isFormsManager />

  return <FormManager {...props} />
}

export default FormManagerWrapper
